<template>
  <DraggableNotes :note="draggableElement" @update:note="updateNotePosition">
    <Transition name="fade">
      <div v-if="isOpen" class="fixed bottom-6 left-1/2 -translate-x-1/2 w-full md:w-[350px] h-fit md:bottom-20 resize z-40 bg-slate-800 dark:bg-gray-800 text-white dark:text-white hover:bg-slate-900 hover:opacity-100 hover:shadow-md p-2 rounded-md min-h-[130px]"
        :style="{ left: draggableElement.x + 'px', top: draggableElement.y + 'px'}">
        <div class="absolute left-2 top-2 handle cursor-grab active:cursor-grabbing z-10 hover:bg-slate-700 rounded-md p-1">
            <ArrowsPointingOutIcon class="size-6 text-white" />
        </div>
        <TriadVideo
          v-if="resolvedType === 'youtube'"
          :url="props.url"
          :metadata="props.metadata"
          :selectedMedia="props.selectedMedia"
          @close="closePlayer"
          @next="emits('next')"
          @previous="emits('previous')"
        />
        <TriadAudio
          v-else
          :url="props.url"
          :metadata="props.metadata"
          :startTime="props.startTime"
          @close="closePlayer"
          @next="emits('next')"
          @previous="emits('previous')"
        />
      </div>
    </Transition>
  </DraggableNotes>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, onMounted, defineExpose, computed } from 'vue';
import TriadVideo from './TriadVideo.vue';
import TriadAudio from './TriadAudio.vue';
import DraggableNotes from './common/elements/DraggableNotes.vue';
import { ArrowsPointingOutIcon } from '@heroicons/vue/24/outline';

const props = defineProps({
  url: {
    type: String
  },
  metadata: {
    type: Object
  },
  type: {
    type: String
  },
  open: {
    type: Boolean
  },
  selectedMedia: {
    type: Object
  },
  startTime: {
    type: Number,
    default: 0
  }
});
const emits = defineEmits(['close', 'next', 'previous', 'open']);

const resolvedType = computed(() => {
  if (props.type === 'youtube') return 'youtube';
  if (props.url && (props.url.includes('youtube') || props.url.includes('youtu.be'))) return 'youtube';
  return props.type;
});

const draggableElement = ref({
  x: window.innerWidth/2,
  y: window.innerHeight - 180,
  width: 0,
  height: 0
});

const isOpen = ref(props.open);
const media = ref(null)
onMounted( () => {
  isOpen.value = props.open
})
watch(() => props.open, (val) => {
  isOpen.value = val;
});

const closePlayer = () => {
  isOpen.value = false;
  emits('close');
};

const updateNotePosition = (updatedNote) => {
    draggableElement.value.x = updatedNote.x;
    draggableElement.value.y = updatedNote.y;
}
const openPlayer = (_media) => {
  if (_media){
    isOpen.value=true;
    media.value = media;
  }
}
defineExpose({openPlayer})
</script> 